import { render, staticRenderFns } from "./JoeyMessage.vue?vue&type=template&id=a71c1e40"
import script from "./JoeyMessage.vue?vue&type=script&lang=ts"
export * from "./JoeyMessage.vue?vue&type=script&lang=ts"
import style0 from "./JoeyMessage.vue?vue&type=style&index=0&id=a71c1e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports